export default __webpack_public_path__ + "static/media/hht2_ep18_timeline_q03_a.4965e5b6.png";